import { render, staticRenderFns } from "./AssignmentProtocol.vue?vue&type=template&id=6a5ba362&"
import script from "./AssignmentProtocol.vue?vue&type=script&lang=js&"
export * from "./AssignmentProtocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports